import '.b0{max-width:1280px;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.db{gap:144px;}.ssr-plugin'
import '.bf{max-width:568px;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { useEffect } from 'react'
import { useContentQuery } from '../../ctx.js'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'

export const VotingIntegrity = () => {
  const track = useTrack('voting-integrity')

  const [lang] = useLanguage()

  const { legalGroupTitle, votingIntegrity, moreInfoReachOut } = useDictionary()
  const { data: info } = useContentQuery('info', null, true)

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <styled.div className="b0 ak o a am db"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bf"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="b3">{legalGroupTitle}</h3>
          <h2 className="b9" style={{ color: colors.primary,}}>
            {votingIntegrity}
          </h2>
        </styled.div>
        {/* column 2 */}
        <styled.div className="ca bf"
          style={{
            '& p': {
              margin: '1em 0em',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: typeof info === 'string' ? info : '',
          }}
        ></styled.div>
      </styled.div>
    </Layout>
  )
}
